import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/users';

class userService {
    updateHasLoggedInBefore(user) {
        return axios.post(`${API_URL}/updateHasLoggedInBefore/${user.uid}`);
    }

    lockUser(user) {
        return axios.put(`${API_URL}/${user.id}/lock`);
    }

    unlockUser(user) {
        return axios.put(`${API_URL}/${user.id}/unlock`);
    }
}

export default new userService();
